Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "OfferingViewImage503669351",
  {"clickable":"OfferingViewImage503669351--clickable","root":"OfferingViewImage503669351--root","imageWrapper":"OfferingViewImage503669351--imageWrapper"},
  "",
  1,
  "OfferingViewImage503669351"
);

